import React from 'react'
import { Link } from 'gatsby'

import Image from '@components/Content/WordPress/Image'

import { MegaMenuCardType } from '@contracts/wp/megaMenu'

import * as styles from './MegaMenuCard.module.scss'

type Props = {
	data: MegaMenuCardType
}

const MegaMenuCard: React.FC<Props> = ({ data }) => {
	return (
		<div className={styles.megaMenuCard}>
			<Link to={data.megaMenuItem.link.uri} className={styles.link}>
				<div className={styles.image}>
					<Image image={data.image} altText="" />
				</div>

				<div className={styles.content}>
					<span>{data.megaMenuItem.label || data.megaMenuItem.link.title}</span>
				</div>
			</Link>
		</div>
	)
}

export default MegaMenuCard
